import { Transformer } from 'unified'
import { visit } from 'unist-util-visit'

import { MdastNode } from './ast-types'

/**
 * Remark plugin that preserves code block language in dataLanguage attribute.
 * This runs BEFORE remark-rehype, so the language survives rehype-prism-plus processing.
 *
 * rehype-prism-plus strips the language-X class for languages it doesn't recognize,
 * so we preserve the language in a data attribute that won't be touched.
 */
const remarkPreserveCodeLanguage = () => {
    const transformer: Transformer = (tree, _file) => {
        visit(tree, 'code', (node: MdastNode) => {
            if (node.lang) {
                if (!node.data) {
                    node.data = { hName: 'pre', hProperties: {} }
                }
                if (!node.data.hProperties) {
                    node.data.hProperties = {}
                }
                node.data.hProperties['dataLanguage'] = node.lang
            }
        })
    }
    return transformer
}

export default remarkPreserveCodeLanguage
